import React, { useState, useEffect } from 'react'
import { useLocation, Link } from 'react-router-dom'
import './AboutPage.scss'
import logoImage_1 from '../../../src/assets/White PNG 1.png'
import logoImage_2 from '../../../src/assets/Black PNG 1.png'
import { CircularProgress } from '@mui/material'
import ReactMarkdown from 'react-markdown'

const AboutPage: React.FC = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const theme = queryParams.get('theme') || 'dark'

  const [aboutContent, setAboutContent] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchAboutContent = async () => {
      try {
        setLoading(true)
        const token = localStorage.getItem('token')
        const headers: HeadersInit = {
          'Content-Type': 'application/json',
        }
        if (token) {
          headers['Authorization'] = `Bearer ${token}`
        }

        const response = await fetch('https://api.neontradepro.com/settings/site', {
          headers: headers, 
        })

        if (response.status === 401) {
          throw new Error('Unauthorized - شما دسترسی ندارید.')
        }
        if (!response.ok) {
          throw new Error('پاسخ شبکه با خطا مواجه شد.')
        }
        const data = await response.json()

        if (data.about_us) {
          setAboutContent(data.about_us)
        } else {
          throw new Error("محتوای 'درباره ما' در پاسخ API یافت نشد.")
        }

      } catch (e: any) {
        setError(`خطا در دریافت اطلاعات: ${e.message}`)
      } finally {
        setLoading(false)
      }
    }
    fetchAboutContent()
  }, [])

  return (
    <div className={`about-page-container ${theme}`} dir='rtl'>
      <header className='about-page-simple-header'>
        <Link to={`/?theme=${theme}`}>
          <img src={theme === 'dark' ? logoImage_1 : logoImage_2} alt='لوگوی نئون' />
        </Link>
      </header>
      <main className='about-page-content'>
        <div className='content-card'>
          <h2>درباره NEON</h2>

          {loading && (
            <div style={{ textAlign: 'center' }}>
              <CircularProgress />
            </div>
          )}

          {error && (
            <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
          )}

          {aboutContent && !loading && !error && (
            <div className="markdown-body" data-theme={theme==="dark"?"dark":"light"}>
              <ReactMarkdown>
                {aboutContent}
              </ReactMarkdown>
            </div>
          )}

        </div>
      </main>
    </div>
  )
}

export default AboutPage